import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';


@Injectable()
export class CalculaLiquidacionService {
  public url!: string;

  constructor(
    public _http: HttpClient
  ) {
  }
  calculaLiquidacion(request : any): Observable<any> {
    let ruta = environment.calculaLiquidacion;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, params, { headers: headersResp });
  }

  getInfoCierreSemanal(data: any){
    let ruta = environment.getInfoCierreSem;
    return this._http.get(ruta + data.partnerId + '/' + data.year + '/' + data.week);
  }

  validarPlantaAutorizada(data: any){
    let ruta = environment.validarPlantaAutorizada;
    return this._http.get(ruta + data.facility + '/' + data.year + '/' + data.week);
  }

  getInfoCierreSemanalFac(data: any){
    let ruta = environment.getInfoCierreSemFac;
    return this._http.get(ruta + data.facility + '/' + data.year + '/' + data.week);
  }

  getConceptos(data: any): Observable<any>{
    let ruta = environment.porConcepto;
    return this._http.get(ruta, {
      params: data
    });
  }
}
